export enum FlkCode {
  AGT_0101_0001 = 'AGT_0101_0001',
  AGT_0101_0002 = 'AGT_0101_0002',
  AGT_01_0011 = 'AGT_01_0011',
  AGT_01_0012 = 'AGT_01_0012',
  AGT_01_0013 = 'AGT_01_0013',
  AGT_01_0014 = 'AGT_01_0014',
  AGT_0901_0002 = 'AGT_0901_0002',
  AGT_0901_0003 = 'AGT_0901_0003',
  AGT_0901_0005 = 'AGT_0901_0005',
  AGT_1301_0003 = 'AGT_1301_0003',
  AGT_34_0001 = 'AGT_34_0001',
  AGT_34_0002 = 'AGT_34_0002',
  AGT_3501_0001 = 'AGT_3501_0001',
  AGT_3501_0002 = 'AGT_3501_0002',
  AGT_3501_0003 = 'AGT_3501_0003',
  AGT_3501_0004 = 'AGT_3501_0004',
  AGT_4701_0002 = 'AGT_4701_0002',
  AGT_4801_0004 = 'AGT_4801_0004',
  AGT_5901_0004 = 'AGT_5901_0004',
  AGT_6401_0008 = 'AGT_6401_0008',
  AGT_7901_0010 = 'AGT_7901_0010',
  AGT_8002_0003 = 'AGT_8002_0003',
  AGT_8601_0001 = 'AGT_8601_0001',
  AGT_8601_0002 = 'AGT_8601_0002',
  AGT_8601_0003 = 'AGT_8601_0003',
  AGT_8601_0004 = 'AGT_8601_0004',
  AGT_8601_0005 = 'AGT_8601_0005',
  AGT_8801_0001 = 'AGT_8801_0001',
  AGT_8801_0002 = 'AGT_8801_0002',
  AGT_8801_0003 = 'AGT_8801_0003',
  AGT_A17_0007 = 'AGT_A17_0007',
  AGT_T03_0002 = 'AGT_T03_0002',
  CLN_1014_0002 = 'CLN_1014_0002',
  ESIA_0201_0002 = 'ESIA_0201_0002',
  KIA_01_01_0002 = 'KIA-01.01_0002',
  OTP_0101_0001 = 'OTP_0101_0001',
  OTP_0101_0002 = 'OTP_0101_0002',
  OTP_0101_0003 = 'OTP_0101_0003',
  OTP_0101_0004 = 'OTP_0101_0004',
  OTP_0201_0001 = 'OTP_0201_0001',
  OTP_0201_0002 = 'OTP_0201_0002',
  OTP_0201_0003 = 'OTP_0201_0003',
  OTP_0201_0004 = 'OTP_0201_0004',
  RL_0201_0001 = 'RL_0201_0001',
  RMM_6010_0001 = 'RMM_6010_0001',
  RMM_6010_0002 = 'RMM_6010_0002',
  RMM_6010_0003 = 'RMM_6010_0003',
  RMM_6010_0004 = 'RMM_6010_0004',
  RMM_6010_0005 = 'RMM_6010_0005',
  RMM_6010_0006 = 'RMM_6010_0006',
  RMM_6010_0007 = 'RMM_6010_0007',
  RMM_6010_0008 = 'RMM_6010_0008',
  RMM_6010_0009 = 'RMM_6010_0009',
  RMM_6010_0010 = 'RMM_6010_0010',
  RMM_6010_0011 = 'RMM_6010_0011',
  RMM_6010_0012 = 'RMM_6010_0012',
  RMM_6010_0013 = 'RMM_6010_0013',
  RMM_6010_0014 = 'RMM_6010_0014',
  RMM_6010_0016 = 'RMM_6010_0016',
  RMM_6010_0019 = 'RMM_6010_0019',
  RMM_6010_0024 = 'RMM_6010_0024',
  RMM_6010_0025 = 'RMM_6010_0025',
  RMM_6010_0026 = 'RMM_6010_0026',
  RMM_6020_0001 = 'RMM_6020_0001',
  RMM_6020_0002 = 'RMM_6020_0002',
  RMM_6020_0003 = 'RMM_6020_0003',
  RMM_6020_0004 = 'RMM_6020_0004',
  RMM_6020_0005 = 'RMM_6020_0005',
  RMM_6020_0006 = 'RMM_6020_0006',
  RMM_6020_0007 = 'RMM_6020_0007',
  RMM_6020_0008 = 'RMM_6020_0008',
  RMM_6020_0010 = 'RMM_6020_0010',
  RMM_6020_0013 = 'RMM_6020_0013',
  RMM_6020_0018 = 'RMM_6020_0018',
  RMM_6020_0019 = 'RMM_6020_0019',
  RMM_6020_0020 = 'RMM_6020_0020',
  RMM_6040_0002 = 'RMM_6040_0002',
  RMM_6050_0015 = 'RMM_6050_0015',
  RMM_6050_0018 = 'RMM_6050_0018',
  RMM_6050_0023 = 'RMM_6050_0023',
  RMM_6050_0024 = 'RMM_6050_0024',
  RMM_6050_0025 = 'RMM_6050_0025',
}
